module.exports = __webpack_public_path__ + "static/img/z1.2ea71b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/z1.png
// module id = WHr/
// module chunks = 1